module.exports = __webpack_public_path__ + "media/img/pages/companies/hug-logo-036bf204a61ff1cedd7b923c72b61187.png";